import React from "react";
import { Navigate ,Outlet} from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken"); // Check token

  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
